import { useId, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RCta } from '../RCta';
import { WregPhase } from '../WregPhase';
import { WregRadioGroup, type WregRadioOption } from '../WregRadioGroup';

type WregScreenerAnswer = 'yes' | 'no';

type WregScreenerOption = WregRadioOption<WregScreenerAnswer>;

type Props = {
  onContinue: () => void;
  onIneligible: () => void;
};

const Q1_OPTIONS: WregScreenerOption[] = [
  ['yes', 'wreg.screener.q1.yes'],
  ['no', 'wreg.screener.q1.no'],
];

const WregScreener = ({ onContinue, onIneligible }: Props) => {
  const { t } = useTranslation();
  const q1LabelId = useId();
  const [htn, setHtn] = useState<WregScreenerAnswer | null>(null);
  const done = Boolean(htn);
  const submit = () => (htn === 'yes' ? onContinue() : onIneligible());
  return (
    <div className="rg-screen">
      <div className="rg-inner rg-inner-head">
        <div className="rg-head-block">
          <WregPhase n={2} />
          <h1 className="rg-h1">{t('wreg.screener.title')}</h1>
          <p className="wreg-screener-sub">{t('wreg.screener.sub')}</p>
        </div>
      </div>
      <div className="rg-list-wrap">
        <div className="rg-list">
          <div className="rg-list-inner rg-opts">
            <div className="wreg-qblock wreg-qcard">
              <div className="wreg-qlabel" id={q1LabelId}>
                {t('wreg.screener.q1.label')}
              </div>
              <WregRadioGroup value={htn} onSelect={setHtn} options={Q1_OPTIONS} labelledBy={q1LabelId} />
            </div>
          </div>
        </div>
      </div>
      <div className="rg-foot">
        <RCta disabled={!done} onClick={submit}>
          {t('wreg.screener.cta')}
        </RCta>
      </div>
    </div>
  );
};

export { WregScreener };
